<template>
    <div class="domain-banner">
        <div class="flex w-full h-100">
            <div class="items-center lg:px-6 w-full lg:py-0 lg:w-2/3 lg:ml-auto">

                <form>
                    <label class="sr-only" for="inlineFormInputGroup">Domain Name</label>
                    <div class="input-group mb-1" :class="{'shake animated': error}">
                        <div class="border border-r-0 border-grey-300 p-2">
                            <div class="text-base sm:text-xl border-0 bg-grey-200 p-2 leading-none">www.</div>
                        </div>
                        <input
                            type="text"
                            v-model="domain"
                            id="inlineFormInputGroup"
                            class="form-control text-base sm:text-xl px-4 leading-none border-l-0 border-grey-300 bg-transparent -ml-4 px-3 pr-1 sm:pr-3 focus-0"
                            placeholder="example.com.au"
                        />
                        <button
                            @click.prevent="action(domain)"
                            :disabled="searching || !domain"
                            class="text-white text-base sm:text-xl bg-green border-0 px-3 sm:px-4 leading-none"
                        >
                            <i v-if="searching"
                                class="far fa-spinner-third fa-spin"
                                title="Please wait while we look up this domain"
                            ></i>
                            <i v-else
                                class="fas"
                                :class="{ 'fa-arrow-right': transfer, 'fa-search': !transfer }"
                                title="Check availability"
                            ></i>
                        </button>
                    </div>
                    <!-- Display error. -->
                    <p v-if="error" class="text-red text-xs">
                        {{ error }}&nbsp;
                    </p>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        transfer: Boolean,
        action: Function,
        searching: Boolean,
        error: String
    },

    data: function () {
        return {
            domain: '',
        };
    },

};

</script>
<style lang="scss" scoped>
     // --breakpoint-lg
    @media (min-width: 992px) {
        .domain-banner {
            background-image: url('/img/apiro-claim-banner.png');
            background-size: cover;
            background-repeat: no-repeat;
            height: 265px;
        }
    }

    // Animation
    .animated {
      animation-duration: 1s;
      animation-fill-mode: both;
    }
    @-webkit-keyframes shake {
      from, to { transform: translate3d(0, 0, 0); }
      10%, 30%, 50%, 70%, 90% { transform: translate3d(-10px, 0, 0); }
      20%, 40%, 60%, 80% { transform: translate3d(10px, 0, 0); }
    }
    @keyframes shake {
        from, to { transform: translate3d(0, 0, 0); }
        10%, 30%, 50%, 70%, 90% { transform: translate3d(-10px, 0, 0); }
        20%, 40%, 60%, 80% { transform: translate3d(10px, 0, 0); }
    }
    .shake { animation-name: shake; }
</style>

<style>
    .domain-tab {
        @apply rounded p-3 mb-5 border-2 border-transparent leading-none inline-block;
    }
    .domain-tab:hover {
        @apply border-green-500 text-green-500;
    }
</style>